export const assertNever = (x: never) => x;
